import React from 'react';

function Privacy() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Privacy Policy</h1>
      </div>

      <div className="page-body">
        <p><em>Last updated: January 11, 2026</em></p>

        <h2>Introduction</h2>
        <p>
          At How To Bachelor ("we", "our", or "us"), we are committed to protecting your privacy.
          This Privacy Policy explains how we collect, use, and safeguard your information when you visit
          our website howtobachelor.com.
        </p>

        <h2>Information We Collect</h2>
        <p>
          We may collect information about you in the following ways:
        </p>

        <h3>Information You Provide</h3>
        <ul>
          <li>Contact information (email address, name) when you reach out to us</li>
          <li>Comments or feedback you submit on our website</li>
          <li>Newsletter subscription information</li>
        </ul>

        <h3>Automatically Collected Information</h3>
        <ul>
          <li>Log data (IP address, browser type, pages visited)</li>
          <li>Cookies and similar tracking technologies</li>
          <li>Usage data and analytics information</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <p>We use the collected information to:</p>
        <ul>
          <li>Provide, operate, and maintain our website</li>
          <li>Improve and personalize your experience</li>
          <li>Understand and analyze how you use our website</li>
          <li>Send you newsletters and updates (with your consent)</li>
          <li>Respond to your comments and questions</li>
        </ul>

        <h2>Cookies</h2>
        <p>
          We use cookies to improve your browsing experience. You can choose to disable cookies through your
          browser settings, but this may affect your ability to use certain features of our website.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          We may use third-party services such as Google Analytics to analyze website traffic and usage.
          These services have their own privacy policies governing the use of your information.
        </p>

        <h2>Data Security</h2>
        <p>
          We implement reasonable security measures to protect your personal information. However, no method
          of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
        </p>

        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your personal information</li>
          <li>Opt-out of marketing communications</li>
        </ul>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting
          the new policy on this page with an updated "Last updated" date.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at:
          <br />
          <strong>contact@howtobachelor.com</strong>
        </p>
      </div>
    </div>
  );
}

export default Privacy;
